<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useHead } from '@unhead/vue'
import ChoicePanel from '@/components/sections/ChoicePanel.vue'

const { t } = useI18n()

useHead({
  title: computed(() => t('seo.title')),
  meta: [
    { name: 'description', content: computed(() => t('seo.description')) },
  ],
})
</script>

<template>
  <main id="main">
    <ChoicePanel />
  </main>
</template>
